import { CDashboardModuleTabComponent, Context } from "./types";

export function findComponentById(element: CDashboardModuleTabComponent, cId: string): CDashboardModuleTabComponent | null {
	if (element.id === cId) return element;
	if (element.childern)
		for (let i = 0; i < element.childern.length; ++i) {
			const com = findComponentById(element.childern[i], cId);
			if (com) return com;
		}
	return null;
}

export function findComponent(root: CDashboardModuleTabComponent, selectedComponentId: string): CDashboardModuleTabComponent | null {
	if (root.id === selectedComponentId) {
		return root;
	}
	if (root.childern)
		for (const child of root.childern) {
			const comp = findComponent(child, selectedComponentId);
			if (comp) {
				return comp;
			}
		}
	return null;
}

export function processDomTreeWithParent(root: CDashboardModuleTabComponent, parent: CDashboardModuleTabComponent | undefined, process: (parent: CDashboardModuleTabComponent | undefined, component: CDashboardModuleTabComponent) => void) {
	process(parent, root);
	if (root.childern)
		for (const child of root.childern) {
			processDomTreeWithParent(child, root, process);
		}
}

export function processDomTree(root: CDashboardModuleTabComponent, process: (root: CDashboardModuleTabComponent) => void) {
	process(root);
	if (root.childern)
		for (const child of root.childern) {
			processDomTree(child, process);
		}
}

export function findParentComponent(root: CDashboardModuleTabComponent, selectedComponentId: string): CDashboardModuleTabComponent | null {
	if (root.id === selectedComponentId) {
		return null;
	}
	if (root.childern)
		for (const child of root.childern) {
			if (child.id === selectedComponentId) {
				return root;
			}
			const parentInChildren = findParentComponent(child, selectedComponentId);
			if (parentInChildren) {
				return parentInChildren;
			}
		}
	return null;
}

export function deleteComponent(root: CDashboardModuleTabComponent, selectedComponentId: string): CDashboardModuleTabComponent {
	const parent = findParentComponent(root, selectedComponentId);
	if (parent) parent.childern = parent.childern.filter((item) => item.id !== selectedComponentId);
	return root;
}

export function evalComponentJsScript(context: Context | undefined, script: string) {
	try {
		if (script.match("{.*}")) {
			return eval(script.replace("{", "").slice(0, -1));
		} else return script;
	} catch (err) {
		return "INVALID_SCRIPT: " + err;
	}
}
